<template>
  <span>
    <el-tooltip
        class="item"
        effect="dark"
        :enterable="false"
        :content="$t('admin.userGroups.assignRole')"
        placement="top-start"
    >
      <i class="el-icon-set-up icon-action" @click="handleOpenDialog" />
    </el-tooltip>

    <el-dialog
        :title="modalTitle"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="450px"
        append-to-body
        @close="handleClose"
    >
      <div class="role-dialog-content">
        <p class="instruction-text">
          Select a role for this user:
        </p>

        <div class="role-cards-container">
          <div
              class="role-card"
              :class="{ 'is-active': selectedRole === 'Shipper' }"
              @click="selectedRole = 'Shipper'"
          >
            <div class="role-card-header">
              <el-radio v-model="selectedRole" label="Shipper" @click.native.prevent>
                Shipper
              </el-radio>
            </div>
            <p class="role-card-desc">
              Create and manage shipments, track deliveries, and access shipping analytics.
            </p>
          </div>

          <div
              class="role-card"
              :class="{ 'is-active': selectedRole === 'Consignee' }"
              @click="selectedRole = 'Consignee'"
          >
            <div class="role-card-header">
              <el-radio v-model="selectedRole" label="Consignee" @click.native.prevent>
                Consignee
              </el-radio>
            </div>
            <p class="role-card-desc">
              View and manage incoming shipments, access delivery details, and track order statuses.
            </p>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
            size="mini"
            @click="handleClose"
            :disabled="isSaving"
        >
          {{ $t('common.cancel') }}
        </el-button>
        <el-button
            type="primary"
            size="mini"
            :disabled="!selectedRole"
            :loading="isSaving"
            :id="'assign-save-button-' + user.user_id"
            @click="handleSave"
        >
          {{ $t('common.save') }}
        </el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>

export default {
  name: 'AssignRoleDialogV2',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      dialogVisible: false,
      selectedRole: null,
      isSaving: false,
    };
  },
  computed: {
    modalTitle() {
      const userName = this.user && this.user.name ? this.user.name : '';
      return `${this.$t('admin.userGroups.assignRole')}: ${userName}`;
    }
  },
  methods: {
    handleOpenDialog() {
      this.selectedRole = null;
      this.isSaving = false;
      this.dialogVisible = true;
    },
    handleClose() {
      if (this.isSaving) return;
      this.dialogVisible = false;
      this.selectedRole = null;
    },
    async handleSave() {
      if (!this.selectedRole) return;

      this.isSaving = true;

      const payload = {
        userId: this.user.user_id,
        userEmail: this.user.email,
        role: this.selectedRole
      };

      try {
        await this.$store.dispatch('userGroups/setRole', payload);
        this.$emit('success');
        this.dialogVisible = false;
        this.$message.success('Role assigned successfully');
        // setTimeout(() => {
        // this.$emit('success');
        // }, 1000);
      } catch (error) {
        this.$message.error('Error assigning role');
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style scoped>
.role-dialog-content {
  display: flex;
  flex-direction: column;
  padding: 10px 15px 20px;
}

.instruction-text {
  margin-bottom: 20px;
  font-size: 14px;
  color: #606266;
}


.role-cards-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.role-card {
  border: 1px solid #DCDFE6;
  border-radius: 6px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #FFFFFF;
}

.role-card:hover {
  border-color: #C0C4CC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.role-card.is-active {
  border-color: #409EFF;
  background-color: #ecf5ff;
}

.role-card-header {
  display: flex;
  align-items: center;
}

.role-card-header ::v-deep .el-radio__label {
  font-weight: bold;
  color: #303133;
}

.role-card-desc {
  margin: 6px 0 0 26px;
  font-size: 13px;
  color: #909399;
  line-height: 1.5;
}
/* -------------------------------- */

.icon-action {
  cursor: pointer;
  font-size: 16px;
  margin: 0 5px;
  /*color: #909399;*/
  transition: color 0.2s;
}

.icon-action:hover {
  color: #409EFF;
}

.dialog-footer {
  text-align: right;
}
</style>
